<div neoDialogTitleContainer class="title-container">
  <cm-icon name="lock" color="warning" size="xs" aria-hidden="true" />
  <h2 neoDialogTitle>Session Expired</h2>
</div>

<div neoDialogContent class="dialog-content">
  <p class="message">Your session timed out due to inactivity.</p>
  <p class="message">Sign in again to continue.</p>
</div>

<div neoDialogActions class="dialog-actions">
  <cm-button variant="flat" color="primary" size="sm" (click)="onRefresh()" autId="session-expired-refresh-btn">
    Sign In Again
  </cm-button>
  <cm-button variant="stroked" color="primary" size="sm" (click)="onGoHome()" autId="session-expired-go-home-btn">
    Go Home
  </cm-button>
</div>
